import React from "react";

import Home from "views/admin/Home";
import About from "views/admin/About";
import Contact from "views/admin/Contact";
import Policy from "views/admin/Policy";
import Footer from "views/admin/Footer";
import Navbar from "views/admin/Navbar";
import Admin from "views/admin/Getlistadmin";
import { BsInfoSquareFill } from "react-icons/bs";
import { MdOutlinePermContactCalendar } from "react-icons/md";
import { MdPolicy } from "react-icons/md";
import { VscLayoutMenubar } from "react-icons/vsc";
import { TbArrowBigDownLineFilled, TbCircleKeyFilled } from "react-icons/tb";
import ChangePassword from "views/admin/ChangePassword";

const routes = [
  {
    name: "Navbar",
    layout: "/admin",
    path: "navbar",
    component: <Navbar />,
    icon: VscLayoutMenubar,
  },
  {
    name: "Home",
    layout: "/admin",
    path: "home",
    component: <Home />,
  },
  {
    name: "About",
    layout: "/admin",
    path: "about",
    component: <About />,
    icon: BsInfoSquareFill,
  },
  {
    name: "Contact",
    layout: "/admin",
    path: "contact",
    component: <Contact />,
    icon: MdOutlinePermContactCalendar,
  },
  {
    name: "Policy",
    layout: "/admin",
    path: "policy",
    component: <Policy />,
    icon: MdPolicy,
  },
  {
    name: "Footer",
    layout: "/admin",
    path: "footer",
    component: <Footer />,
    icon: TbArrowBigDownLineFilled,
  },
  {
    name: "Form Submissions",
    layout: "/admin",
    path: "submissions",
    component: <Admin />,
  },
  {
    name: "Change Password",
    layout: "/admin",
    path: "change-password",
    component: <ChangePassword />,
    icon: TbCircleKeyFilled,
  },
];

export default routes;
